import { Factory } from 'miragejs';
import faker from 'faker';

export default Factory.extend({
  name() {
    const suffix =
      Math.round() > 0.5 ? 'Secondary School' : 'Elementary School';
    return `${faker.name.lastName()} ${suffix}`;
  },
  totalTeachers() {
    return Math.round(Math.random() * 10);
  },
  type() {
    return 'School';
  },
  district() {
    return null;
  },
  teacherCountClosure() {
    return faker.datatype.number(100);
  },
  maxLicenseCount() {
    return faker.datatype.number(100);
  },
  remainingLicenseCount() {
    // return Math.floor(Math.random() * (this.maxLicenseCount - 0 + 1) + 0);
    return faker.datatype.number({ min: 0, max: this.maxLicenseCount });
  },
  maxLicenseCountInClosure() {
    return faker.datatype.number({ min: 0, max: 2 * this.maxLicenseCount });
  },
  remainingLicenseCountInClosure() {
    return faker.datatype.number({
      min: 0,
      max: this.maxLicenseCountInClosure,
    });
  },
  districtLicencesAvailable() {
    return faker.datatype.number(100);
  },
  incomingSubscriptionAllotments() {
    return faker.datatype.number(100);
  },
  numberOfSeatsInSubscriptions() {
    return faker.datatype.number(100);
  },
  outgoingSubscriptionAllotments() {
    return faker.datatype.number(100);
  },
  city() {
    return faker.address.city();
  },
  state() {
    return faker.address.city();
  },
  country() {
    return faker.address.city();
  },
  postalCode() {
    return faker.address.city();
  },
});
